import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ChangePasswordWithTokenDto } from '../model/changue-password-with-token-dto';
import { PasswordResetToken } from '../model/password-reset-token';


@Injectable()
export class PasswordResetService {
  private Dto: ChangePasswordWithTokenDto;

  passwordResetToken: PasswordResetToken;
  constructor(private http: HttpClient) { }

  getToken(): PasswordResetToken {
    return this.passwordResetToken;
  }

  updateToken(token: PasswordResetToken) {
    this.passwordResetToken = token;
  }

  resetToken() {
    this.passwordResetToken = undefined;
  }

  requestPasswordReset(usuario: string): Observable<boolean> {
    return this.http.post<boolean>(`${environment.API_BASE}/passwordReset/request`, { userId: usuario });
  }

  validatePasswordResetToken(token: PasswordResetToken): Observable<PasswordResetToken> {
    return this.http.post<PasswordResetToken>(`${environment.API_BASE}/passwordReset/validate`, token);
  }

  executePasswordReset(token: PasswordResetToken): Observable<any> {
    const Dto = new ChangePasswordWithTokenDto(token.uid, token.password, undefined, token.token);

    return this.http.post<any>(environment.API_BASE + '/Users/ChanguePasswordWithToken', Dto);
  }
}
